import { worker } from 'core/test/msw/browser';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { ENV } from 'utils/env';
import App from './core/App';
import { persistor, store } from './redux/store';

const container = document.getElementById('root')!;
const root = createRoot(container);

if (ENV.APP_IN_MEMORY) {
    worker.start();
}

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <App />
            </PersistGate>
        </Provider>
    </React.StrictMode>,
);
